import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'ap-back-to-list-button',
    templateUrl: './back-to-list-button.component.html',
    standalone: false
})
export class BackToListButtonComponent implements OnInit {

  @Input() defaultLocation = '';

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {

  }

  backPage() {
    const currentUrl = this.router.url.split('?')[0];
    let url = sessionStorage.getItem('from_page');
    if (!url || currentUrl === url) {
      url = this.defaultLocation;
    }
    const filterState = sessionStorage.getItem('filter_on');
    filterState == 'true' ? this.router.navigate([url], { queryParams: { filter: 'on' } }) : this.router.navigate([url]);
  }

}
